// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BInO","title":"styles_title__2NgxA"};